import { $http } from "@/assets/js/appFunc";
import i18n from "@/i18n";
import Vue from "vue";

/* Gets the Smtp's configuration */
function showSMSNotification() {
    Vue.prototype.$toast.showNotify({
        type: "success",
        message: i18n.t("admin.messagingCom.testSmsModal.notification")
    });
}

function showEmailNotification() {
    Vue.prototype.$toast.showNotify({
        type: "success",
        message: i18n.t("admin.messagingCom.testEmailModal.notification")
    });
}
function showSaveNotification() {
    Vue.prototype.$toast.showNotify({
        type: "success",
        message: i18n.t("admin.messagingCom.saveNotification")
    });
}

export const getConfigSMTP = (context) => {
    const req = {
        type: "GET",
        url: "/notification/config/smtp"

    };
    $http(req, true).then(
        data => context.commit("setConfigSMTP", data),
        error => console.log(error)
    );
};

/* Gets the sms's properties */

export const getConfigSMS = (context) => {
    const req = {
        type: "GET",
        url: "/notification/config/sms"

    };
    $http(req, true).then(
        data => context.commit("setConfigSMS", data),
        error => console.log(error)
    );
};

/* Updates the configuration of Smtp */

export const updateConfigSmtp = (context, config) => {
    let host = config.host.split(":");
    let port = config.requiresTls ? 465 : 25;

    if (host[1]) {
        if ((config.requiresTls && parseInt(host[1], 10) !== 25) || (!config.requiresTls && parseInt(host[1], 10) !== 465)) {
            port = parseInt(host[1], 10);
        }
    }

    host = host[0];

    config.host = host;
    config.port = port;

    const req = {
        type: "POST",
        url: "/notification/config/smtp",
        data: config
    };

    $http(req, true).then(
        data => {
            context.commit("setConfigSMTP", { data: config });
        },
        error => console.log(error)
    );
};

/* Updates the configuration of SMS */

export const updateConfigSMS = (context, config) => {
    const req = {
        type: "POST",
        url: "/notification/config/sms",
        data: config
    };
    $http(req, true).then(
        data => {
            showSaveNotification();
            context.commit("setConfigSMS", { data: config });
        },
        error => console.log(error)
    );
};

/* Sends a new notification via email */

export const sendEmail = (context, newEmail) => {
    const req = {
        type: "POST",
        url: " /notification/config/smtp/test",
        data: newEmail
    };
    $http(req, true).then(
        data => {
            context.commit("setEmail", { data: newEmail });
            showEmailNotification();
        },
        error => console.log(error)
    );
};

/* Sends a SMS notification to a list of receivers */

export const sendSms = (context, newSms) => {
    const req = {
        type: "POST",
        url: " /notification/config/sms/test",
        data: newSms
    };
    $http(req, true).then(
        data => {
            context.commit("setSms", { data: newSms });
            showSMSNotification();
        },
        error => console.log(error)

    );
};
/* get configuration for other option enabled */

export const getOtherConfiguration = (context, smsGatewayInfo) => {
    const req = {
        type: "POST",
        url: "/notification/config/other",
        data: smsGatewayInfo,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};
